


























































import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IHisInfoSelectDialog } from "./IHisInfoSelectDialog";
import { HisInformation, HisInformationItem } from "../../../domain/his";
import { HisItemParameter, InformationKinds, HisItemBehaviorFactory } from "../../../domain/his/behavior";
import { IHisInformationGroupSource, HisInformationListItemGroupSource } from "../../../domain/his/groupInput/HisInformationGroupSource";
import { HisInformationListItem } from "../../../domain/his/HisInformationListItem";
import { HisInformationTable } from "../../../domain/his/HisInformationTable";
import { Table, Header } from "../../../domain/system/table";
import { DialogMixin } from "../../system/mixins";
import MultiHisInfoSelector from "../selectors/MultiHisInfoSelector.vue";
import DateFormatEditor from "../../document/editor/propertyEditors/DateFormatEditor.vue";
import { DepartmentFilter, DepartmentGroupFilter, DiseaseFilter } from "../selectors";
import { EditingDocument } from "../../document/editor";
import { ISortParameter } from "../../system";
import { IHisInformationSelectorSortConfiguration } from "../../../domain/configuration";

@Component({
  components: {
    MultiHisInfoSelector,
    DateFormatEditor, // TODO: 日付書式セレクタの共通コンポーネントを作成したい
    DepartmentFilter,
    DepartmentGroupFilter,
    DiseaseFilter,
  },
})
export default class HisInfoListSelectDialog extends Mixins(DialogMixin) implements IHisInfoSelectDialog {
  @Prop()
  hisInformation: HisInformation;
  @Prop()
  parameter: HisItemParameter;

  @Prop({ default: undefined})
  selectedItems: HisInformationListItem[];

  @Prop()
  editingDocument: EditingDocument;

  currentPage: number;
  dateFormat: string;
  result: HisInformationListItemGroupSource;
  selectedOptions: HisInformationListItem[];
  departmentFilter: (s: HisInformationListItem) => boolean;
  departmentGroupFilter: (s: HisInformationListItem) => boolean;
  diseaseFilter: (s: HisInformationListItem) => boolean;

  data(): any {
    return {
      currentPage: 1,
      dateFormat: "Y 年 M 月 D 日",
      selectedOptions: undefined as HisInformationListItem[],
      result: null as HisInformationListItemGroupSource,
      departmentFilter: (s: HisInformationListItem) => true,
      departmentGroupFilter: (s: HisInformationListItem) => true,
      diseaseFilter: (s: HisInformationListItem) => true,
    };
  }

  $refs!: {
    departmentFilter: DepartmentFilter;
    diseaseFilter: DiseaseFilter;
    selector: MultiHisInfoSelector;
  };

  get filteredOptions(): HisInformationListItem[] {
    return Enumerable.from(this.options)
      .where(this.departmentFilter)
      .where(o => !this.isHospitalization || !this.isDepartmentGroupEnabled || this.departmentGroupFilter(o))
      .where(o => !this.isDisease || this.diseaseFilter(o))
      .toArray();
  }

  get informationKind(): InformationKinds {
    return this.nullToPartial(this.parameter).informationKind;
  }

  get isMultiSelect(): boolean {
    return this.nullToPartial(this.parameter).isMultiSelect;
  }

  get parameterKey(): string {
    return this.nullToPartial(this.parameter).key;
  }

  get title(): string {
    return this.name + "選択";
  }

  get name(): string {
    switch (this.informationKind) {
      case InformationKinds.Disease: return "病名情報";
      case InformationKinds.Hospitalization: return "入院情報";
      case InformationKinds.Operation: return "手術情報";
    }
    return "";
  }

  get isDisease(): boolean {
    return this.informationKind === InformationKinds.Disease;
  }

  get isHospitalization(): boolean {
    return this.informationKind === InformationKinds.Hospitalization;
  }

  get isDepartmentGroupEnabled(): boolean {
    return this.$configuration.behavior.departmentGroup.feature.isEnable;
  }
  
  get headers(): Header[] {
    const headers = this.nullToPartial(this.table).headers;
    return !!headers ? headers : [];
  }

  get keys(): string[] {
    const keys = this.nullToPartial(this.hisInfoTable).keys;
    return !!keys ? keys : [];
  }

  get options(): HisInformationListItem[] {
    const items = this.nullToPartial(this.hisInfoTable).items;
    return !!items ? Enumerable.from(items).select((i, n) => this.addIndexToItem(i, n)).toArray() : [];
  }

  get defaultSortParameter(): ISortParameter {
    return this.toSortParameter(this.getDefaultSortConfiguration());
  }

  getDefaultSortConfiguration(): IHisInformationSelectorSortConfiguration {
    const configuration = this.$configuration.behavior.document.editor.hisInformationSelector.defaultSort;
    switch (this.informationKind) {
      case InformationKinds.Disease: return configuration.disease;
      case InformationKinds.Hospitalization: return configuration.hospitalization;
      case InformationKinds.Operation: return configuration.operation;
    }
    return null;
  }

  toSortParameter(source: IHisInformationSelectorSortConfiguration): ISortParameter {
    if (!source || !source.key) { return null; }
    return {
      property: source.key,
      order: source.isDescending ? "descending" : "ascending",
    };
  }

  addIndexToItem(option: HisInformationListItem, index: number): HisInformationListItem {
    option.items.push(new HisInformationItem("INDEX", index.toString()));
    return option;
  }

  get hasSelected(): boolean {
    return this.nullToPartial(this.selectedOptions).length > 0;
  }

  get hisInfoTable(): HisInformationTable {
    if (this.table == null) { return null; }

    return new HisInformationTable(this.table);
  }

  get table(): Table {
    switch (this.informationKind) {
      case InformationKinds.Disease: return this.hisInformation.diseaseCollection;
      case InformationKinds.Hospitalization: return this.hisInformation.hospitalizationCollection;
      case InformationKinds.Operation: return this.hisInformation.operationCollection;
    }
    return null;
  }

  get displayCountPerPage(): number {
    return this.$configuration.behavior.document.editor.hisInformationSelector.displayCountPerPage;
  }

  @Watch("isVisible")
  onChangedIsVisible(newValue: boolean, oldValue: boolean): void {
    if (!newValue) { return; }
    // ダイアログが開いた際に診療科による絞り込み設定がされていた場合設定
    // テーブルの初期化（スクロール、列幅）
    // コンポーネントの参照が必要なので表示された後に初期化を実行
    this.$nextTick(() => {
      const filter = this.$refs.departmentFilter;
      filter.setOptions();
      filter.setDefaultDepartment();
      this.$refs.diseaseFilter.setOptions();
      const selector = this.$refs.selector;
      selector.fitForceColumnWidths();
      selector.resetScrollPosition();
    });
  }

  async show(): Promise<IHisInformationGroupSource> {
    if (!this.isSelectable(this.parameterKey)) {
      return undefined;
    }

    return this.showModal(async () => {
      this.currentPage = 1;
      this.selectedOptions = this.selectedItems;
      this.setResult();
      await this.waitHidden();
      return this.result;
    });
  }

  cancel(): void {
    this.selectedOptions = undefined;
    this.setResult();
    this.close();
  }

  clear(): void {
    this.selectedOptions = null;
    this.setResult();
    this.close();
  }

  select(): void {
    this.setResult();
    this.close();
  }

  onSelectInput(): void {
    this.select();
  }

  private close(): void {
    this.isVisible = false;
  }

  private setResult(): void {
    this.result = new HisInformationListItemGroupSource(this.selectedOptions, this.dateFormat);
  }

  private nullToPartial<T>(value: T): Partial<T> {
    return (value != null) ? value : {};
  }

  equivalentValidator(source: HisInformationListItem, destination: HisInformationListItem): boolean {
    return (source === destination) || this.isEqualSelectedOptions(source.items, destination.items);
  }

  private isEqualSelectedOptions(source: HisInformationItem[], destination: HisInformationItem[]): boolean {
    return Enumerable.from(source)
      .all(s => s.value === Enumerable.from(destination)
        .where(d => d.name === s.name)
        .select(d => d.value)
        .firstOrDefault());
  }

  private isSelectable(key: string): boolean {
    // WF依頼作成の入院情報選択はkey未指定
    return key
      ? this.hasValue(key)
      : this.options && this.options.length > 0;
  }

  private hasValue(key: string): boolean {
    return Enumerable.from(this.options ? this.options : [])
      .any(o => {
        const behavior = HisItemBehaviorFactory.create(key, this.dateFormat);
        const hisInfoValue = behavior.getValue(o.items);
        return hisInfoValue && Enumerable.from(hisInfoValue.data ? hisInfoValue.data : []).any(v => !!v);
      });
  }
}
